"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEX_REGEX = exports.CTA_TEXT_MAX_LENGTH = exports.DESCRIPTION_MAX_LENGTH = exports.HEADING_MAX_LENGTH = exports.MAX_NAME_LENGTH = exports.MIN_NAME_LENGTH = void 0;
var MIN_NAME_LENGTH = 1;
exports.MIN_NAME_LENGTH = MIN_NAME_LENGTH;
var MAX_NAME_LENGTH = 255;
exports.MAX_NAME_LENGTH = MAX_NAME_LENGTH;
var HEADING_MAX_LENGTH = 180;
exports.HEADING_MAX_LENGTH = HEADING_MAX_LENGTH;
var DESCRIPTION_MAX_LENGTH = 1000;
exports.DESCRIPTION_MAX_LENGTH = DESCRIPTION_MAX_LENGTH;
var CTA_TEXT_MAX_LENGTH = 80;
exports.CTA_TEXT_MAX_LENGTH = CTA_TEXT_MAX_LENGTH;
var HEX_REGEX = RegExp(/^#[a-fA-F0-9]{6}$/);
exports.HEX_REGEX = HEX_REGEX;